import React, { useRef } from 'react';
import { Grid, InputAdornment } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { TextField, useGlobal } from '@rcg/ui-react';
import Calendar from '@rcg/ui-react/lib/assets/svg/calendar';
import Modal from '@rcg/ui-react/lib/components/FullScreenModal/Modal';
import useModal from '@rcg/ui-react/lib/components/FullScreenModal/hooks';
import Theme from '@rcg/ui-react/lib/theme';
import Mobile from '../Mobile';
import useStyles from './index.style';

const InputsDate = (props) => {
  const {
    dividerInputIcon = <Calendar />,
    resetDatesButtonLabel,
    incomingStartDate,
    incomingEndDate,
    minAvailableDate,
    yourDatesLabel,
    maxAvailableDate,
    submitDatesButtonLabel,
    datepickerIcon = <Calendar />,
    datepickerEndIcon = <Calendar />,
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    labelStartDate = 'Departure date',
    labelEndDate = 'Return date',
    cancelButtonLabel = 'Cancel',
    backOptionLabel,
    startDate = new Date(),
    endDate = new Date(),
    onDateChange = () => {},
    resetCalendar = () => {},
    oneWay = true,
  } = props;
  const btnOpenModal = useRef(null);
  const classes = useStyles();
  const {
    data: { localizedDayjs },
  } = useGlobal();
  const isXl = useMediaQuery(Theme.breakpoints.up('xl'));
  const {
    modalProps,
    open: openModal,
    close: closeModal,
  } = useModal({
    background: '#FFF',
  });

  const handleOpenModal = () => {
    openModal(btnOpenModal);
  };

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <div>
      <Grid
        container
        ref={btnOpenModal}
        spacing={isXl ? 4 : 3}
        alignItems="flex-end"
        aria-controls="menu-list-grow"
        aria-haspopup="true"
        onClick={handleOpenModal}>
        <Grid item xs={12} sm={oneWay ? 12 : 6} className={classes.gridItem}>
          <TextField
            name="startDateMobile"
            data-testid="startDateMobile"
            label={labelStartDate}
            placeholder={placeholderStartDate}
            value={startDate && localizedDayjs(startDate).format('ddd, MMM DD')}
            InputProps={{
              startAdornment: <InputAdornment position="start">{datepickerIcon}</InputAdornment>,
              readOnly: true,
            }}
          />
        </Grid>
        {!oneWay && (
          <Grid item xs={12} sm={6} className={classes.gridItem}>
            <TextField
              name="endDateMobile"
              label={labelEndDate}
              placeholder={placeholderEndDate}
              value={endDate && localizedDayjs(endDate).format('ddd, MMM DD')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">{datepickerEndIcon}</InputAdornment>
                ),
                readOnly: true,
              }}
            />
          </Grid>
        )}
      </Grid>
      <Modal {...modalProps} padding={false} closeButton={false}>
        <Mobile
          datepickerIcon={datepickerIcon}
          dividerInputIcon={dividerInputIcon}
          resetDatesButtonLabel={resetDatesButtonLabel}
          incomingStartDate={incomingStartDate}
          incomingEndDate={incomingEndDate}
          minAvailableDate={minAvailableDate}
          backOptionLabel={backOptionLabel}
          maxAvailableDate={maxAvailableDate}
          startDate={startDate}
          endDate={endDate}
          yourDatesLabel={yourDatesLabel}
          submitDatesButtonLabel={submitDatesButtonLabel}
          placeholderStartDate={placeholderStartDate}
          placeholderEndDate={placeholderEndDate}
          handleCloseModal={handleCloseModal}
          cancelButtonLabel={cancelButtonLabel}
          onDateChange={onDateChange}
          resetCalendar={resetCalendar}
          oneWay={oneWay}
        />
      </Modal>
    </div>
  );
};

export default InputsDate;
